export default __webpack_public_path__ + "static/media/ic_gmx_custom.1e4ac4aa.svg";